export var hasLinksInBlock = function (block, contentState) {
    try {
        // editor
        if (block.findEntityRanges) {
            return !!getLinkRangesInBlock(block, contentState).length;
        }
        // viewer
        if (block.entityRanges && block.entityRanges.length) {
            return block.entityRanges.some(function (entityRange) {
                var entityMap = contentState.get('entityMap');
                var entityKey = entityMap[entityRange.key];
                var entity = contentState.getEntity(entityKey);
                var entityType = entity.type;
                if (entityType === 'LINK' ||
                    entityType === 'wix-draft-plugin-external-link') {
                    return true;
                }
                return false;
            });
        }
    }
    catch (e) {
        return false;
    }
};
function getLinkRangesInBlock(block, contentState) {
    var ranges = [];
    block.findEntityRanges(function (value) {
        var key = value.getEntity();
        return key && contentState.getEntity(key).type === 'LINK';
    }, 
    // @ts-ignore
    function (start, end) { return ranges.push([start, end]); });
    return ranges;
}
//# sourceMappingURL=draftUtils.js.map